<template>
  <section class="adjust-policy-info">
    <div class="flex-sb">
      <div class="flex-1">
        <template v-if="isRefer">
          <adjust-premium-edit
            ref="adjust-premium"
            :form="formData"
            :oldForm="oldForm"
            @submit="getPremiumForm"/>
        </template>

        <h3 v-if="!hasExcess">Excess</h3>
        <!-- <excess-form
          v-if="isRefer"
          ref="excess-form"
          :formDataLock="formDataLock"
          :form="{
            ...formData,
            ...premiumData
          }"/> -->
        <product-excess-form
          v-if="isRefer&&!hasExcess"
          ref="excess-form"
          :formDataLock="formDataLock"
          :form="{
            ...formData,
            ...premiumData
          }" />
        <excess-info
          v-if="!isRefer&&!hasExcess&&!isHzmb"
          :formData="{
            ...formData,
            ...premiumData
          }"/>

        <div v-if="productId == 11">
          <h3>Policyholder</h3>
          <policy-holder-info
            :form="formData"
            :oldForm="oldForm"
            :isEndorsement="true"/>

          <h3>Insured Vehicle</h3>
          <insured-vehicle-info-compare
            :form="formData"
            :oldForm="oldForm"/>

          <h3>Insured Driver(s)</h3>
          <drivers-info
            :form="formData"
            :preFormData="oldForm"
            :isEndorsement="true"/>
        </div>
        <div v-else>
          <h2>Client Info</h2>
          <housemaid-quote-info
            v-if='productId == 12'
            :formData="formData"
            :oldForm="oldForm"
            :isEndorsement="true"
          />
          <decoration-quote-info
            v-else-if="productId == 15"
            :formData="form"
            :oldForm="oldForm"
            :isEndorsement="true"
          />
          <homefire-quote-info
            v-else-if="productId == 17"
            Account
            :formData="form"
            :oldForm="oldForm"
            :isEndorsement="true"
          />
          <student-quote-info
            v-else-if="productId == 16"
            Account
            :formData="form"
            :oldForm="oldForm"
            :isEndorsement="true"
          />
          <working-quote-info
            v-else-if="productId == 13"
            Account
            :formData="form"
            :oldForm="oldForm"
            :isEndorsement="true"
          />
          <personal-quote-info
            v-else-if="productId == 18"
            Account
            :formData="form"
            :oldForm="oldForm"
            :isEndorsement="true"
          />
          <travel-quote-info
            v-else-if="productId == 14"
            Account
            :formData="form"
            :oldForm="oldForm"
            :isEndorsement="true"
          />
          <fire-quote-info
            v-else-if="productId == 20"
            Account
            :formData="form"
            :oldForm="oldForm"
            :isEndorsement="true"
          />
          <drone-quote-info
            v-else-if="productId == 21"
            Account
            :formData="form"
            :oldForm="oldForm"
            :isEndorsement="true"
          />
          <pet-quote-info
            v-else-if="productId == 22"
            Account
            :formData="form"
            :oldForm="oldForm"
            :isEndorsement="true"
          />
        </div>

        <h3>Remark(s)</h3>
        <div class="table">
          <div class="tr">
            <span>Remark</span>
            <span>{{ formData.remark }}</span>
          </div>
        </div>
        <!-- refer 時不存在 -->
        <template v-if="!isRefer">
          <!--          <div v-if="productId==11">-->
          <!--            <h3>Premium</h3>-->
          <!--            <premium-info :form="premiumData"/>-->
          <!--          </div>-->
          <div
            class="box">
            <h3>Premium</h3>
            <div class="table">
              <div class="tr th">
                <span>Item</span>
                <span>Amount</span>
              </div>
              <div
                v-for="(item,index) in premiumArr"
                :key="`table${index}`"
                class="tr">
                <span>{{item.name}}</span>
                <span>{{ item.premium }}</span>
                <!-- <span>{{ premiumData.base_prm | value | formatMoney }}</span> -->
              </div>
              <!--              <div class="tr">-->
              <!--                <span>Basic Premium</span>-->
              <!--                &lt;!&ndash;                <span>-</span>&ndash;&gt;-->
              <!--                <span>{{ formData.pre_basic_prm | formatMoney(2, true) }}</span>-->
              <!--                &lt;!&ndash; <span>{{ formData.basic_prm | formatMoney(2, true) }}</span> &ndash;&gt;-->
              <!--              </div>-->

              <!--              <div class="tr">-->
              <!--                <span>IA Levy</span>-->
              <!--                &lt;!&ndash;                <span>{{ formData.ia_levy_pct }}%</span>&ndash;&gt;-->
              <!--                <span>{{ formData.ia_levy_vl | formatMoney(2, true) }}</span>-->
              <!--              </div>-->
              <!--              <div-->
              <!--                v-if="productId == 15 && formData.ec_levy_pct > 0"-->
              <!--                class="tr">-->
              <!--                <span>EC Levy</span>-->
              <!--                <span>{{ formData.ec_levy_vl | formatMoney(2, true) }}</span>-->
              <!--              </div>-->
              <!--              <div class="tr">-->
              <!--                <span>MGM Discount</span>-->
              <!--                &lt;!&ndash;                <span>-</span>&ndash;&gt;-->
              <!--                <span>{{ formData.code_disc_prm | formatMoney(2, true) }}</span>-->
              <!--              </div>-->
              <!--              <div-->
              <!--                v-if="formData.coupon_vl>0"-->
              <!--                class="tr">-->
              <!--                <span>Coupon Discount</span>-->
              <!--                &lt;!&ndash;              <span>MGM Discount {{ premiumData.code_disc_pct }}%</span>&ndash;&gt;-->
              <!--                <span>{{ formData.coupon_vl | formatMoney(2, true) }}</span>-->
              <!--              </div>-->
              <!--              <div-->
              <!--                v-if="formData.promo_disc_prm>0"-->
              <!--                class="tr">-->
              <!--                <span>Promo Discount</span>-->
              <!--                &lt;!&ndash;              <span>MGM Discount {{ premiumData.code_disc_pct }}%</span>&ndash;&gt;-->
              <!--                <span>{{ formData.promo_disc_prm | formatMoney(2, true) }}</span>-->
              <!--              </div>-->
              <!--              <div-->

              <!--                class="tr">-->
              <!--                <span>Manual Discount</span>-->
              <!--                <span>{{ premiumData.spec_disc_prm | value | formatMoney }}</span>-->
              <!--              </div>-->
              <!--              <div class="tr">-->
              <!--                <span>Total</span>-->
              <!--                &lt;!&ndash;                <span>-</span>&ndash;&gt;-->
              <!--                <span>{{ formData.amount | formatMoney(2, true) }}</span>-->
              <!--              </div>-->
            </div>
          </div>
        </template>
      </div>
      <div
        v-if="!isRefer"
        class="aside">
        <div class="card">
          <div class="table">
            <div
              v-for="(item,index) in premiumArr"
              :key="index"
              class="tr">
              <span>{{item.name}}</span>
              <span>{{ item.premium }}</span>
              <!-- <span>{{ premiumData.base_prm | value | formatMoney }}</span> -->
            </div>
            <!--            <div-->
            <!--              v-if="productId == 11"-->
            <!--              class="tr">-->
            <!--              <span>Surcharge</span>-->
            <!--              <span>{{ premiumData.surcharge | value | formatMoney }}</span>-->
            <!--              &lt;!&ndash; <span>{{ premiumData.base_prm | value | formatMoney }}</span> &ndash;&gt;-->
            <!--            </div>-->
            <!--            <div class="tr">-->
            <!--              <span>NCD</span>-->
            <!--              <span>{{ premiumData.cfd_amt | value | formatMoney }}</span>-->
            <!--            </div>-->
            <!--            <div class="tr">-->
            <!--              <span>MGM Discount</span>-->
            <!--              &lt;!&ndash;              <span>MGM Discount {{ premiumData.code_disc_pct }}%</span>&ndash;&gt;-->
            <!--              <span>{{ premiumData.code_disc_prm | value | formatMoney }}</span>-->
            <!--            </div>-->
            <!--            <div-->
            <!--              v-if="premiumData.coupon_vl>0"-->
            <!--              class="tr">-->
            <!--              <span>Coupon Discount</span>-->
            <!--              &lt;!&ndash;              <span>MGM Discount {{ premiumData.code_disc_pct }}%</span>&ndash;&gt;-->
            <!--              <span>{{ premiumData.coupon_vl | value | formatMoney }}</span>-->
            <!--            </div>-->
            <!--            <div-->
            <!--              v-if="premiumData.promo_disc_prm>0"-->
            <!--              class="tr">-->
            <!--              <span>Promo Discount</span>-->
            <!--              &lt;!&ndash;              <span>MGM Discount {{ premiumData.code_disc_pct }}%</span>&ndash;&gt;-->
            <!--              <span>{{ premiumData.promo_disc_prm | value | formatMoney }}</span>-->
            <!--            </div>-->
            <!--            <div class="tr">-->
            <!--              <span>MIB {{ premiumData.mib_pct }}%</span>-->
            <!--              <span>{{ premiumData.mib_vl | value | formatMoney }}</span>-->
            <!--            </div>-->
            <!--            <div-->
            <!--              v-if="premiumData.spec_disc_prm>0"-->
            <!--              class="tr">-->
            <!--              <span>Manual Discount</span>-->
            <!--              <span>{{ premiumData.spec_disc_prm | value | formatMoney }}</span>-->
            <!--            </div>-->
            <!--            <div-->
            <!--              v-if="formData.class_id != 14"-->
            <!--              class="tr">-->
            <!--              <span>IA Levy</span>-->
            <!--              <span>{{ premiumData.ia_levy_vl | value | formatMoney }}</span>-->
            <!--            </div>-->
            <!--            <div-->
            <!--              v-if="productId == 15 && premiumData.ec_levy_pct > 0"-->
            <!--              class="tr">-->
            <!--              <span>EC Levy</span>-->
            <!--              <span>{{ premiumData.ec_levy_vl | value | formatMoney }}</span>-->
            <!--            </div>-->
            <!--            &lt;!&ndash;            <div class="tr">&ndash;&gt;-->
            <!--            &lt;!&ndash;              <span>&ndash;&gt;-->
            <!--            &lt;!&ndash;                Admin Charge <br/>&ndash;&gt;-->
            <!--            &lt;!&ndash;                <v-input&ndash;&gt;-->
            <!--            &lt;!&ndash;                  v-model="premiumData.handling_fee"&ndash;&gt;-->
            <!--            &lt;!&ndash;                  prepend="$"&ndash;&gt;-->
            <!--            &lt;!&ndash;                  @input="inputHandlingFee"/>&ndash;&gt;-->
            <!--            &lt;!&ndash;              </span>&ndash;&gt;-->
            <!--            &lt;!&ndash;            </div>&ndash;&gt;-->
            <!--            <div class="tr">-->
            <!--              <span>Premium Before Adjustment</span>-->
            <!--              <span>{{ premiumData.before_premium | value | formatMoney }}</span>-->
            <!--            </div>-->
            <!--            <div class="tr">-->
            <!--              <span>Premium After Adjustment</span>-->
            <!--              <span>{{ premiumData.after_premium | value | formatMoney }}</span>-->
            <!--            </div>-->
          </div>
          <div class="card-bottom">
            <!-- if price stays the same -->
            <section v-if="premiumData.difference == 0">
              <span class="title">No price difference</span>
              <p>All documents of this policy will be regenerated.</p>
            </section>
            <!-- if price is refund -->
            <!-- if need payment -->
            <section v-else>
              <span>Difference </span>
              <span
                :style="{ fontSize: cssFontSize(premiumData.difference, 170, 24) }"
                class="amount">{{ premiumData.difference | value | formatMoney }}</span>
              <!-- <p>The difference must be refunded/requested in the next step.</p>
              <p>All documents of this policy will be regenerated.</p> -->
              <p v-if="premiumData.difference < 0">The difference will be added to this policy’s balance. It can be
                refunded once this policy is turned from New Business to New Policy.</p>
              <p v-else>An adjustment quote will be generated for this policy. This adjustment will only take effect
                once the quote has been paid.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import PolicyHolderInfo from '@/views/tickets/components/info/policy-holder-info'
import InsuredVehicleInfoCompare from '@/views/components/insured-vehicle-info-compare'
import DriversInfo from '@/views/tickets/components/info/drivers-info'
import AdjustPremiumEdit from './form/adjust-premium-edit'
// import PremiumInfo from './info/premium-info'
import MixinFormat from '@/mixins/format'
import MixinOptions from '@/mixins/options'
import OMath from '@/utils/math'
import ExcessInfo from '@/views/tickets/components/info/excess-info'
// import ExcessForm from '@/views/tickets/components/form/excess-form'
import DecorationQuoteInfo from '@/views/components/modules/decoration/decoration-quote-info'
import HomefireQuoteInfo from '@/views/components/modules/homefire/homefire-quote-info'
import fireQuoteInfo from '@/views/components/modules/homefire/fire-quote-info'
import HousemaidQuoteInfo from '@/views/components/modules/housemaid/housemaid-quote-info'
import ProductExcessForm from '@/views/tickets/components/form/product-excess-form'
import StudentQuoteInfo from '@/views/components/modules/student/student-quote-info'
import PersonalQuoteInfo from '@/views/components/modules/personal/personal-quote-info'
import WorkingQuoteInfo from '@/views/components/modules/working/working-quote-info'
import TravelQuoteInfo from '@/views/components/modules/travel/travel-quote-info'
import DroneQuoteInfo from '@/views/components/modules/drone/drone-quote-info'
import petQuoteInfo from '@/views/components/modules/pet/pet-quote-info'

export default {
  name: 'AdjustPolicyInfo',
  components: {
    DroneQuoteInfo,
    TravelQuoteInfo,
    WorkingQuoteInfo,
    StudentQuoteInfo,
    PolicyHolderInfo,
    InsuredVehicleInfoCompare,
    DriversInfo,
    AdjustPremiumEdit,
    // PremiumInfo,
    ExcessInfo,
    // ExcessForm,
    HousemaidQuoteInfo,
    DecorationQuoteInfo,
    HomefireQuoteInfo,
    ProductExcessForm,
    fireQuoteInfo,
    PersonalQuoteInfo,
    petQuoteInfo
  },
  mixins: [MixinFormat, MixinOptions],
  props: {
    isRefer: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    premium: {
      type: Object,
      default: () => ({})
    },
    premiumArr: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      formData: {},
      premiumData: {
        handling_fee: '',
      },
      formDataLock: 0,
      premiumForm: {
        // excess
        tppd_ex: '',
        tppd_young_driver_ex: '',
        tppd_inexp_driver_ex: '',
        tppd_unnamed_driver_ex: '',
        remark: ''
      }
    }
  },
  computed: {
    productId() {
      return this.form.product_id || 11
    },
    hasExcess(){
      return [13,14,16].includes(this.productId)
    },
    isHzmb(){
      let {class_id} = this.form||{}
      return class_id == 15
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val))
        // Object.keys(this.premiumForm).some(key => {
        //   this.premiumForm[key] = val[key]
        // })
      }
    },
    premium: {
      immediate: true,
      deep: true,
      handler(val) {
        let params = JSON.parse(JSON.stringify(val))
        this.premiumData = Object.assign(this.premiumData, params)
        // Object.keys(this.premiumForm).some(key => {
        //   this.premiumForm[key] = val[key]
        // })
        this.formDataLock += 1
        this.premiumForm = JSON.parse(JSON.stringify(this.premiumData))
      }
    }
  },
  methods: {
    getPremiumForm(form) {
      const excessParams = this.$refs['excess-form'].submitForm()
      const params = Object.assign(excessParams, form)
      // 校驗 excess
      this.$emit('submit', params)
    },
    submitForm() {
      if (this.isRefer) {
        this.$refs['adjust-premium'].submitForm()
      } else {
        this.$emit('submit', this.premiumData)
      }
    },
    inputHandlingFee(val) {
      const value =Number( OMath.round(val))
      const beforePremium = Number(OMath.round(this.premiumData.before_premium))
      const afterPremium = Number(OMath.round(this.premiumData.after_premium))
      const result = OMath.round(afterPremium + value - beforePremium)
      this.$set(this.premiumData, 'difference', result)
    },
    network() {
      return {}
    }
  }
}
</script>
<style lang="scss" scoped>
.adjust-policy-info {
  h3 {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .aside {
    margin-left: 15px;
    width: 200px;

    .card-bottom {
      margin: 15px -15px -15px;
      padding: 15px;
      background: #ECF5FF;
      font-size: 14px;

      span {
        display: block;
        padding-bottom: 5px;
        color: #616266;
      }

      .title {
        font-size: 16px;
      }

      .amount {
        display: block;
        padding-bottom: 5px;
        color: #409EFF;
        font-size: 24px;
        font-weight: bold;
      }

      p {
        padding-bottom: 10px;
        color: #91939A;
      }
    }
  }
}
</style>
